import { render, staticRenderFns } from "./PrivateAuctionProductChip.vue?vue&type=template&id=f1f8d510&scoped=true"
import script from "./PrivateAuctionProductChip.vue?vue&type=script&lang=js"
export * from "./PrivateAuctionProductChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f8d510",
  null
  
)

export default component.exports